var _defs, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLicenseInactive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-0{fill:none;}\n            .cls-1{fill:#fff;}\n            .cls-2{fill:#efeff0;}\n            .cls-3{fill:#d2ddfa;}\n            .cls-4{fill:#b4c6fa;}\n            .cls-5{fill:#4a77f6;}\n            .cls-6{fill:#668fff;}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M8.67,10.86c0-.06,0-.11,0-.17H8.62A3.46,3.46,0,0,1,5.08,7.32,3.46,3.46,0,0,1,8.62,3.94H11a3.49,3.49,0,0,1,3.47,2.8l4.09-5A2,2,0,0,0,17,1H3A2,2,0,0,0,1,3V21a2,2,0,0,0,.61,1.43L8.67,13.8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M10.91,10.69v.36l.32-.38-.26,0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-0",
    d: "M11,6.19H8.62a1.13,1.13,0,1,0,0,2.25H11a1.13,1.13,0,1,0,0-2.25Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M11,8.44H8.62a1.13,1.13,0,1,1,0-2.25H11a1.13,1.13,0,1,1,0,2.25Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M18.54,1.74l-4.09,5a2.79,2.79,0,0,1,.07.58,3.44,3.44,0,0,1-3.28,3.35l-.32.38v5.13h3A1.14,1.14,0,0,1,15,17.23v.13a1.15,1.15,0,0,1-1.12,1.18h-3v.28A1.12,1.12,0,0,1,8.68,19V13.8L1.61,22.43A2,2,0,0,0,3,23H17a2,2,0,0,0,2-2V3A2,2,0,0,0,18.54,1.74ZM14,15.2H12.75a1.18,1.18,0,0,1-.12-2.35h1.25A1.15,1.15,0,0,1,15,14,1.17,1.17,0,0,1,14,15.2Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M21.25,1H19.5a1.82,1.82,0,0,1,1,1.62V21.38a1.82,1.82,0,0,1-1,1.62h1.75A1.58,1.58,0,0,0,23,21.25V2.75A1.58,1.58,0,0,0,21.25,1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicenseInactive);
export default __webpack_public_path__ + "static/media/license-inactive.058169ca855b24b88bdae4689674f1e9.svg";
export { ForwardRef as ReactComponent };